import { VariableType } from 'json-to-graphql-query';
import { EntityResource } from './entity.resource';
/**
 * Resource zgód
 *
 * @export
 * @class ConsentResource
 * @extends {EntityResource<Consent>}
 */
export class ConsentResource extends EntityResource {
    constructor() {
        super({
            entityName: 'consent'
        });
        this.getFields = {
            id: true,
            accepted: true
        };
        this.listFields = {
            id: true,
            accepted: true,
            terms: {
                id: true
            }
        };
        this.addVariables = { input: 'ConsentInput!' };
        this.addArgs = { input: new VariableType('input') };
        this.updateVariables = { id: 'Int!', input: 'ConsentInput!' };
        this.updateArgs = {
            id: new VariableType('id'),
            input: new VariableType('input')
        };
        this.listVariables = { filters: 'ConsentFilters' };
    }
}
export const consentResource = new ConsentResource();
//# sourceMappingURL=consent.resource.js.map